import React from 'react'
import { PropTypes } from 'prop-types'
import { useForm } from 'react-hook-form';

import {setLanguage} from "redux-i18n"
import languageData from "../../data/languageData";
import auth from '../../components/common/Auth';
import { Redirect } from 'react-router-dom'

import { Card, Col, Container, Form, Row } from 'react-bootstrap';

import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import ErrorMessage from '../../components/common/ErrorMessage';

import SelectCombobox from '../../components/common/SelectCombobox';
import { ButtonsSaveAndCancel } from '../../components/common/ButtonsSaveAndCancel';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';


export const Language = (props, context) => {

    // const { i18nState } = useSelector(state => state.i18nState);
    const { lang } = useSelector(state => state.i18nState);


    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
        defaultValues: {
            
            // Configured language
            language_id: lang,
            languages: languageData(),

            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }
    });


    const dispatch = useDispatch();

    // Function calls at form submit
    const onSubmit = data => {
        console.log("TODO: persist user preference:" + data);
        dispatch(setLanguage(getValues().language_id));
        setValue("onSubmitOk", true);
    }

    // If OnSubmit was success, redirect to user list
    if (getValues().onSubmitOk){
        return <Redirect to='/settings/user-settings' />
    }

    return (
        <Container fluid>
            <ErrorMessage message={getValues().backendError}/>
            <PageHeaderStandar title={context.t('Language')} subtitle={context.t('Settings')} />
            <Card small="true" style={{ marginBottom: '20px'}}>
                <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px"}}>
                    <Col lg="12" >
                        <Row >
                            <SelectCombobox
                                name= "language_id" 
                                label={ context.t('Language') }
                                valueOptions={ getValues().languages } 
                                // valueSelected= { register.defaultValues }
                                errors={ errors }
                                useFormRegister= {
                                    register("language_id", { 
                                    value: getValues.language_id,
                                    required: context.t("Must select an option"), 
                                    })
                                }
                            />
                        </Row>
                        <hr/>
                        <ButtonsSaveAndCancel context={context}/>
                    </Col>
                </Form>
            </Card>
        </Container>
    )
}

Language.contextTypes = {
    t: PropTypes.func
}

export default Language;